export const emailRegex = /^[\w !#$%&'*+./=?^`{|}~-]+@[\d.A-Za-z-]+\.[\dA-Za-z-]+$/;
export const phoneRegex = /^(\+\d{1,4})?\d{6,15}$/;
export const numberRegex = /^\d+(\d+)?$/;
export const batchValueRegex = /^\d+(\.\d+)?$/;
export const fileFormatRegex = /\/(jpg|jpeg|png|pdf)/;
export const couponCodeRegex = /^\w+$/;
export const upperLettersRegex = /[A-Z]+/;
export const specialCharsRegex = /\W+/;
export const requiredVatRegex = /^(IT|FR|DE|ES|PL|GB)$/;
export const areDigitRegex = /\d/;

export const vatNumberRegEx = {
  it: /^(\d{11})$/,
  fr: /^((FR)[\dA-Z]{2}\d{9})$/,
};

export const zipCodeRegex = {
  it: /^(\d{5})$/,
  fr: /^(\d{2} ?\d{3})$/,
  de: /^(\d{5})$/,
  es: /^(\d{5})$/,
  pl: /^(\d{2}-\d{3})$/,
  gb: /^(GIR ?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]? ?\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\d{1,4})$/,
};

//TODO: move these functions to useValidator custom hook
export const hasUpperLetter = (value: string): boolean => upperLettersRegex.test(value);
export const hasSpecialChar = (value: string): boolean => specialCharsRegex.test(value);
export const hasDigits = (value: string): boolean => areDigitRegex.test(value);
export const minLength = (value: string, length: number): boolean => value.length >= length;
export const shouldRequireVat = (countryCode = ''): boolean => requiredVatRegex.test(countryCode);
